import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { initializeFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"

export const firebaseConfig = {
  apiKey: "AIzaSyAF8V-ojJP2NWuZgKLKTUoYY5bwUmcDf9Q",
  authDomain: "discoversvaneti.firebaseapp.com",
  projectId: "discoversvaneti",
  storageBucket: "discoversvaneti.firebasestorage.app",
  messagingSenderId: "1015050015633",
  appId: "1:1015050015633:web:b0459b89a599da49cb0030",
  measurementId: "G-NFKBRM3Y9P"
}

export const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
// experimentalAutoDetectLongPolling avoids the WebChannel transport hanging
// (net::ERR_TIMED_OUT on Write/channel & Listen/channel) under throttled/lab
// network conditions like Lighthouse's.
export const db = initializeFirestore(app, { experimentalAutoDetectLongPolling: true })

// Cloudinary config
export const CLOUDINARY_CLOUD_NAME = 'dgi0bwach'
export const CLOUDINARY_UPLOAD_PRESET = 'vydhzyap'